<div #graphContainer class="graphContainer">
  <div class="funnel" [class.na]="na===true"></div>
</div>
